import { render } from "./instructionsdetaileditor.vue?vue&type=template&id=010f8263"
import script from "./instructionsdetaileditor.vue?vue&type=script&lang=js"
export * from "./instructionsdetaileditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__